import { query } from "../../../app/query";
import { Options } from "../../../common/types/requestOptions";

export enum MessageTemplateName {
  TalentRejection = "TalentRejection",
}

export type MessageTemplateQueryParams = {
  name: MessageTemplateName;
  bundleId?: string;
  jobAdId?: string;
};

export type MessageTemplateQueryResponse = {
  message: string;
};

export const getMessageTemplate = (
  params: MessageTemplateQueryParams,
  options: Options = {},
): Promise<MessageTemplateQueryResponse> =>
  query<MessageTemplateQueryParams, MessageTemplateQueryResponse>(
    "/projections/qry/messageTemplate",
    params,
    options,
  );
